import fetch from "cross-fetch";
import * as constants from "../utils/constants";

export default class NeurosphereService {
  static headers = {
    "Content-Type": "application/json",
    "Access-Control-Allow-Credentials": true,
  };

  static updateParams(params) {
    if (!params["show_BTSC"]) {
      // Disable BTSC transformation by setting too high value
      return Object.assign({}, params, {
        t_transformation: constants.T_TRANSFORMATION_DISABLED,
        cell_type: params["init_cell_type"].toLowerCase(),
        lattice_size: params["lattice_size"].toLowerCase(),
      });
    } else {
      return Object.assign({}, params, {
        cell_type: params["init_cell_type"].toLowerCase(),
        lattice_size: params["lattice_size"].toLowerCase(),
      });
    }
  }

  static requestSim(params, callback, errMsg) {
    const APIparams = NeurosphereService.updateParams(params);

    return (
      fetch(constants.API_BASEURL + "neurosphere", {
        method: "POST",
        headers: this.headers,
        body: JSON.stringify(APIparams),
      })
        .then(handleErrors)
        .then((r) => r.json())
        .then((r) => ({
          video: r["video"],
          data: this.formatToCSV(JSON.parse(r["data"])),
        }))
        .then(callback)
        .catch(errMsg)
    );
  }

  static formatToCSV(data) {
    let CSVdata = [["Time", "Cell Position : Cell Type"]];
    for (var key of Object.keys(data)) {
      let row = [];
      row.push(`${key}`);
      for (var key2 of Object.keys(data[key])) {
        row.push(`${key2} : ${data[key][key2]}`);
      }
      CSVdata.push(row);
    }

    return CSVdata;
  }
}

function handleErrors(response) {
  if (!response.ok) {
    console.log("error in service");
    console.log(response);
    throw Error(response.statusText);
  }
  return response;
}
